'use strict';

var _shared = require('./_shared');
var _ = require('lodash');

module.exports = {
    /**
     * Converts favoriteMeal data from API into dto object with helpful data and mapping logic already done
     * for you.
     * @param {object} menuModel menuModel w/ data
     * @param {object} favoriteMeal favoriteMeal data from API
     */
    fromFavoriteMealToDTO: function fromFavoriteMealToDTO(menuModel, favoriteMeal) {
        var products = [];

        _.forEach(favoriteMeal.items, function (menuItem) {
            var a = menuItem.products;

            var menuItemId = _.isUndefined(menuItem.menuItemId) ? false : menuItem.menuItemId;
            if (!menuItemId) {
                products = false;
                return false;
            }
            if (a.length > 1) {
                //combo
                var comboProducts = [];
                for (var i = 0; i < a.length; i++) {
                    var product = a[i];
                    var salesItemId = _.isUndefined(product.salesItemId) ? false : product.salesItemId;
                    if (!salesItemId) {
                        comboProducts = false;
                        break;
                    }
                    comboProducts.push(_shared.mapCoreFavoriteItemTo(menuModel, product, menuItemId));
                }

                if (!comboProducts) {
                    products = false;
                    return false;
                }
                products = products.concat(comboProducts);
            } else {
                //not combo
                products.push(_shared.mapCoreFavoriteItemTo(menuModel, a[0], menuItemId));
            }
        });

        return {
            products: products
        };
    },

    /**
     * Maps a product or an array of products into favorite meal data for API calls
     * @param {Array<Product>|Product} orderProducts
     * @returns {Array}
     */
    mapToFavoriteData: function mapToFavoriteData(orderProducts) {
        var self = this;
        var items = [];
        var products;

        //when a bag is favorited, the order data comes in as an array of products
        //and when a product is favorited, the order data comes in as the product object
        if (Array.isArray(orderProducts)) {
            products = orderProducts;
        } else {
            products = [orderProducts];
        }

        if (products && products.length) {
            products.forEach(function (product) {
                var i = self.mapProductToFavoriteData(product);
                items.push(i);
            });
        }
        return items;
    },

    mapProductToFavoriteData: function mapProductToFavoriteData(product) {

        var itemsInCombo = [];
        itemsInCombo.push({ salesItem: product.salesItem, modifiers: product.modifiers });
        if (product.isCombo) {
            product.comboProducts.forEach(function (cp) {
                itemsInCombo.push({ salesItem: cp.salesItem, modifiers: cp.modifiers });
            });
        }

        var quantity;
        if (product.quantity) {
            quantity = product.quantity;
        }

        var products = [];

        itemsInCombo.forEach(function (item) {
            var salesItem = item.salesItem;
            var modifiers = item.modifiers;
            var components = [];
            var product = {
                salesItemId: salesItem.salesItemId,
                quantity: quantity,
                components: components
            };

            if (modifiers && modifiers.length) {
                modifiers.forEach(function (modifier) {
                    var component = {
                        action: modifier.action,
                        quantity: modifier.quantity,
                        modifierGroupId: modifier.modifierGroupId,
                        modifierId: modifier.salesItemOptionId
                    };

                    components.push(component);
                });
            }
            products.push(product);
        });

        var favoriteData = {
            menuItemId: product.menuItem.menuItemId,
            products: products
        };

        return favoriteData;
    },
    urlifyFavoriteName: function urlifyFavoriteName(mealName) {
        if (mealName) {
            return mealName.replace(/[^a-zA-Z0-9]+/g, '');
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/mappers/favoriteMeal.js
// module id = 843
// module chunks = 0